import { QuoteActions } from 'components/common-form/sidePanel/actions/quote/QuoteActions';
import { WorkspaceTabOwnProps } from 'shared/connect/connect';
import { QuoteWorkspaceType } from 'state/workspaces/model';

interface StateProps {}

interface Props extends StateProps, WorkspaceTabOwnProps<QuoteWorkspaceType> {}

export function HalfQuoteActions({ formId, workspace, children }: Props) {
  return (
    <div className="d-flex flex-wrap ">
      <QuoteActions tabId={formId} workspaceType={workspace} width="half" btnClassName="px-1">
        {children}
      </QuoteActions>
    </div>
  );
}
